module.exports = __webpack_public_path__ + "img/pic_zfbzf.5b9987f2.png";